<app-modal>
    <h2 class="mb-0100">
        {{isCreate ? 'Add' : 'Edit' }} Shift
    </h2>
    <app-shift-info-form [formControl]="shiftInfoControl">
    </app-shift-info-form>
    <mat-dialog-actions>
        <button mat-button
                [disabled]="shiftInfoControl.invalid"
                class="btn"
                (click)="onSaveClick()">Save</button>
    </mat-dialog-actions>
</app-modal>
